import arrowImg from "../../../../picture/PlayLanguage.png";
import { useEffect, useRef, useState } from "react";

// values are objects {id, name}[]
const CustomSelectMultiple = ({
  allValues,
  selectedValues,
  onSelectChange,
  label,
  displayNumber = false,
  style = {}
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const selectRef = useRef(null);
  const optionsRef = useRef(null);

 const handleOpen = () => {
  if (!isOpen) {
    const rect = selectRef.current.getBoundingClientRect();
    const optionsHeight = Math.min(allValues.length * 37, 200); // max 200px
    optionsRef.current.style.width = rect.width + "px";
    optionsRef.current.style.top = rect.top - optionsHeight + "px";
    optionsRef.current.style.left = rect.left + "px";
  }
  setIsOpen(!isOpen);
};

  const handleSelect = (value) => {
    if (onSelectChange) onSelectChange(value);
  };

  useEffect(() => {
    const rect = selectRef.current.getBoundingClientRect();
  const optionsHeight = Math.min(allValues.length * 37, 200);
  optionsRef.current.style.width = rect.width + "px";
  optionsRef.current.style.top = rect.top - optionsHeight + "px";
  optionsRef.current.style.left = rect.left + "px";

    function handleClickOutside(event) {
      if (selectRef.current && !selectRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div ref={selectRef} style={style}>
      <div
        style={{ fontWeight: "bold", fontSize: "16px", marginBottom: "5px" }}
      >
        {label}
      </div>
      <div onClick={handleOpen} style={{ position: "relative" }}>
        <input
          type="text"
          value={displayNumber ? selectedValues.length || "" : ""}
          readOnly
          style={{
            width: "100%",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            fontSize: "16px",
            height: "40px",
            padding: "10px"
          }}
        />
        <div
          style={{
            width: "30px",
            position: "absolute",
            right: "0px",
            top: "12px"
          }}
        >
          <img
            src={arrowImg}
            alt=""
            className="profile-select-item-img"
            style={{ transform: isOpen ? "rotate(-90deg)" : "rotate(90deg)" }}
          />
        </div>
      </div>
      <div
        ref={optionsRef}
        style={{
          position: "fixed",
          zIndex: "10",
          display: isOpen ? "block" : "none",
          boxShadow: "0px 5px 10px rgba(0, 0, 0, 0.15)",
          maxHeight: "200px",
          overflowY: "auto",
        }}
      >
        {allValues.map((value) => (
          <div
            key={value.id}
            onClick={() => handleSelect(value)}
            style={{
              wordBreak: "break-word",
              padding: "5px 10px",
              borderBottom: "1px solid black",
              cursor: "pointer",
              backgroundColor: selectedValues.find((v) => v.id === value.id)
                ? "lightgrey"
                : "white",
              display: "flex",
              alignItems: "center",
              fontSize: "16px",
              gap: "5px"
            }}
          >
            <input
              type="checkbox"
              checked={!!selectedValues.find((v) => v.id === value.id)}
              onChange={() => {}}
            />
            <div>{value.name}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CustomSelectMultiple;